export const headerNavData = {
    blog : [
        {
            title: "Top Stories and News",
            href: `${process.env.NEXT_PUBLIC_FRONTEND_HOST}/news/`,
            icon: "/icons/storiesAndNews.svg"
        },
        {
            title: "Car and Bike reviews",
            href: `${process.env.NEXT_PUBLIC_FRONTEND_HOST}/reviews/`,
            icon: "/icons/navReviews.svg"
        },
        {
            title: "Interesting articles",
            href: `${process.env.NEXT_PUBLIC_FRONTEND_HOST}/articles/`,
            icon: "/icons/navArticles.svg"
        },
    ],
    buyCar : [
        {
            title: "New car",
            href: "/cars/",
            icon: "/icons/navNewCar.svg",
            hasSubMenu: true,
        },
        {
            title: "Express Delivery",
            href: "/collection/express-delivery+cars/",
            icon: "/icons/navExpressDelivery.svg"
        },
        {
            title: "Electric Vehicles",
            href: "/collection/electric+cars/",
            icon: "/icons/navElectricVehicle.svg"
        },
    ]
};